import createRoute   from '@widesk-ui/tools/createRoute';
import TaxonomyModel from '@models/website/TaxonomyModel';

const route = createRoute.customFromService(
	`Sélection des ${TaxonomyModel.localize('plural', 'l')}`,
	'/website_entertainments/:websiteEntertainmentId/taxonomy_selection',
	'website',
	'TaxonomySelection',
);

export default route;
